// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/logout.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_header__lm1EH {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100px;
  padding: 15px 16px 0 16px;
  transition: height 0.6s ease-out, padding 0.6s ease-out, transform 0.6s ease-out;
}
.styles_header__lm1EH button {
  width: fit-content;
}
@media (min-width: 768px) {
  .styles_header__lm1EH {
    padding: 15px 100px 0 100px;
  }
}

.styles_headerCompact__xr0rs {
  height: 60px;
  padding-top: 8px;
}
.styles_headerCompact__xr0rs .styles_logoContainer__OCFRX {
  transform: scale(0.6);
  transform-origin: left center;
}
.styles_headerCompact__xr0rs .styles_settingsContainer__hzMYQ {
  transform: scale(0.6);
  transform-origin: right center;
}

.styles_headerAnimating__xXtsk .styles_logoContainer__OCFRX,
.styles_headerAnimating__xXtsk .styles_settingsContainer__hzMYQ {
  transition: transform 0.6s ease-out;
}

@keyframes styles_shimmer__fNVbx {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}
.styles_shimmer__fNVbx {
  position: relative;
  overflow: visible;
}
.styles_shimmer__fNVbx::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.8) 50%, transparent 100%);
  background-size: 200% 100%;
  animation: styles_shimmer__fNVbx 1.5s ease-in-out;
  pointer-events: none;
  border-radius: inherit;
}

.styles_logoContainer__OCFRX {
  display: flex;
  align-items: center;
  gap: 12px;
  font: var(--typography-h2);
  cursor: pointer;
  width: 40px;
}
@media (min-width: 768px) {
  .styles_logoContainer__OCFRX {
    width: 56px;
    gap: 14px;
    font: var(--typography-logo);
  }
}

.styles_headerLogo__z95Lk {
  height: 40px;
  width: auto;
}
@media (min-width: 768px) {
  .styles_headerLogo__z95Lk {
    height: 56px;
  }
}

.styles_settingsContainer__hzMYQ {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
}

.styles_mobileOnly__BZSmu {
  display: block;
}
@media (min-width: 768px) {
  .styles_mobileOnly__BZSmu {
    display: none;
  }
}

.styles_desktopAvatar__wTUtZ {
  display: none;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
}
@media (min-width: 768px) {
  .styles_desktopAvatar__wTUtZ {
    display: block;
  }
}

.styles_userButtonAvatar__w3GF8 {
  width: 48px !important;
  height: 48px !important;
  border-radius: 50% !important;
}

.styles_userButtonPopoverCard__VlzFB {
  margin-top: 10px;
  max-width: fit-content;
  border-radius: 8px;
  border: 1px solid var(--color-gray-strokes);
  background: var(--color-white);
  box-shadow: 0 12px 16px -4px rgba(127, 127, 127, 0.08), 0 4px 6px -2px rgba(127, 127, 127, 0.03);
}

.styles_popoverActionButton__D0VZS,
.styles_popoverCustomItemButton__pIMSQ,
.styles_popoverActions__6jlbb {
  border: none !important;
  padding: 8px !important;
  border-radius: 8px;
  font: var(--typography-body-m-regular);
  color: var(--color-black);
}
.styles_popoverActionButton__D0VZS svg,
.styles_popoverCustomItemButton__pIMSQ svg,
.styles_popoverActions__6jlbb svg {
  width: 20px;
  height: 20px;
  margin-right: 8px;
}

.styles_userPreview__UjdPI {
  padding: 8px 16px !important;
}

.styles_identifierText__0dK\\+9 {
  font: var(--typography-body-m-medium);
}

.styles_secondaryIdentifierText__Pr7iF {
  font: var(--typography-body-s-regular);
}

.styles_hide__q8J6s {
  display: none !important;
}

.styles_signOutIcon__IVM9z {
  display: none !important;
}

.styles_signOutIconBox__E3cFO::before {
  content: "";
  display: inline-block;
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: contain;
  background-repeat: no-repeat;
}

.styles_sidebarToggle__DW2A6 {
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 12px;
  color: #64748b;
  transition: color 0.2s;
}
.styles_sidebarToggle__DW2A6:hover {
  color: #2563eb;
}
.styles_sidebarToggle__DW2A6 svg {
  width: 24px;
  height: 24px;
}`, "",{"version":3,"sources":["webpack://./src/components/header/styles.module.scss","webpack://./src/styles/mixins.scss"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,yBAAA;EACA,gFAAA;AAAF;AAEE;EACE,kBAAA;AAAJ;ACJE;EDNF;IAcI,2BAAA;EAAF;AACF;;AAIA;EACE,YAAA;EACA,gBAAA;AADF;AAGE;EACE,qBAAA;EACA,6BAAA;AADJ;AAIE;EACE,qBAAA;EACA,8BAAA;AAFJ;;AAQE;;EAEE,mCAAA;AALJ;;AAUA;EACE;IACE,4BAAA;EAPF;EASA;IACE,2BAAA;EAPF;AACF;AAUA;EACE,kBAAA;EACA,iBAAA;AARF;AAUE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,kGAAA;EAMA,0BAAA;EACA,iDAAA;EACA,oBAAA;EACA,sBAAA;AAbJ;;AAiBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,0BAAA;EACA,eAAA;EACA,WAAA;AAdF;AC9DE;EDsEF;IASI,WAAA;IACA,SAAA;IACA,4BAAA;EAbF;AACF;;AAgBA;EACE,YAAA;EACA,WAAA;AAbF;AC1EE;EDqFF;IAKI,YAAA;EAZF;AACF;;AAeA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;AAZF;;AAgBA;EACE,cAAA;AAbF;AAeE;EAHF;IAII,aAAA;EAZF;AACF;;AAgBA;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAbF;AAeE;EAPF;IAQI,cAAA;EAZF;AACF;;AAeA;EACE,sBAAA;EACA,uBAAA;EACA,6BAAA;AAZF;;AAeA;EACE,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,2CAAA;EACA,8BAAA;EACA,gGAAA;AAZF;;AAgBA;;;EAGE,uBAAA;EACA,uBAAA;EACA,kBAAA;EACA,sCAAA;EACA,yBAAA;AAbF;AAeE;;;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAXJ;;AAeA;EACE,4BAAA;AAZF;;AAeA;EACE,qCAAA;AAZF;;AAeA;EACE,sCAAA;AAZF;;AAeA;EACE,wBAAA;AAZF;;AAeA;EACE,wBAAA;AAZF;;AAeA;EACE,WAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;AAZF;;AAeA;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,cAAA;EACA,sBAAA;AAZF;AAcE;EACE,cAAA;AAZJ;AAeE;EACE,WAAA;EACA,YAAA;AAbJ","sourcesContent":["@import \"mixins\";\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  height: 100px;\n  padding: 15px 16px 0 16px;\n  transition: height 0.6s ease-out, padding 0.6s ease-out, transform 0.6s ease-out;\n\n  button {\n    width: fit-content;\n  }\n\n  @include md {\n    padding: 15px 100px 0 100px;\n  }\n}\n\n// Compact header for calendar page (40% smaller)\n.headerCompact {\n  height: 60px;\n  padding-top: 8px;\n\n  .logoContainer {\n    transform: scale(0.6);\n    transform-origin: left center;\n  }\n\n  .settingsContainer {\n    transform: scale(0.6);\n    transform-origin: right center;\n  }\n}\n\n// Animating state - smooth transition\n.headerAnimating {\n  .logoContainer,\n  .settingsContainer {\n    transition: transform 0.6s ease-out;\n  }\n}\n\n// Shimmer effect\n@keyframes shimmer {\n  0% {\n    background-position: -200% 0;\n  }\n  100% {\n    background-position: 200% 0;\n  }\n}\n\n.shimmer {\n  position: relative;\n  overflow: visible;\n\n  &::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: linear-gradient(\n      90deg,\n      transparent 0%,\n      rgba(255, 255, 255, 0.8) 50%,\n      transparent 100%\n    );\n    background-size: 200% 100%;\n    animation: shimmer 1.5s ease-in-out;\n    pointer-events: none;\n    border-radius: inherit;\n  }\n}\n\n.logoContainer {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font: var(--typography-h2);\n  cursor: pointer;\n  width: 40px;\n\n  @include md {\n    width: 56px;\n    gap: 14px;\n    font: var(--typography-logo);\n  }\n}\n\n.headerLogo {\n  height: 40px;\n  width: auto;\n\n  @include md {\n    height: 56px;\n  }\n}\n\n.settingsContainer {\n  display: flex;\n  flex-direction: row; // Make sure it's row, not column\n  align-items: center;\n  gap: 12px; // Space between items\n}\n\n// Show only on mobile (hide on desktop where sidebar is shown)\n.mobileOnly {\n  display: block;\n\n  @media (min-width: 768px) {\n    display: none;\n  }\n}\n\n// Desktop profile picture in header (hidden on mobile)\n.desktopAvatar {\n  display: none;\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  object-fit: cover;\n\n  @media (min-width: 768px) {\n    display: block;\n  }\n}\n\n.userButtonAvatar {\n  width: 48px !important;\n  height: 48px !important;\n  border-radius: 50% !important;\n}\n\n.userButtonPopoverCard {\n  margin-top: 10px;\n  max-width: fit-content;\n  border-radius: 8px;\n  border: 1px solid var(--color-gray-strokes);\n  background: var(--color-white);\n  box-shadow: 0 12px 16px -4px rgba(127, 127, 127, 0.08),\n    0 4px 6px -2px rgba(127, 127, 127, 0.03);\n}\n\n.popoverActionButton,\n.popoverCustomItemButton,\n.popoverActions {\n  border: none !important;\n  padding: 8px !important;\n  border-radius: 8px;\n  font: var(--typography-body-m-regular);\n  color: var(--color-black);\n\n  svg {\n    width: 20px;\n    height: 20px;\n    margin-right: 8px;\n  }\n}\n\n.userPreview {\n  padding: 8px 16px !important;\n}\n\n.identifierText {\n  font: var(--typography-body-m-medium);\n}\n\n.secondaryIdentifierText {\n  font: var(--typography-body-s-regular);\n}\n\n.hide {\n  display: none !important;\n}\n\n.signOutIcon {\n  display: none !important;\n}\n\n.signOutIconBox::before {\n  content: \"\";\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  background-image: url(\"../../assets/logout.svg\");\n  background-size: contain;\n  background-repeat: no-repeat;\n}\n\n.sidebarToggle {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-left: 12px;\n  color: #64748b;\n  transition: color 0.2s;\n  \n  &:hover {\n    color: #2563eb;\n  }\n  \n  svg {\n    width: 24px;\n    height: 24px;\n  }\n}\n","@mixin sm {\n  @media (min-width: 640px) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media (min-width: 768px) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media (min-width: 1024px) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media (min-width: 1280px) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `styles_header__lm1EH`,
	"headerCompact": `styles_headerCompact__xr0rs`,
	"logoContainer": `styles_logoContainer__OCFRX`,
	"settingsContainer": `styles_settingsContainer__hzMYQ`,
	"headerAnimating": `styles_headerAnimating__xXtsk`,
	"shimmer": `styles_shimmer__fNVbx`,
	"headerLogo": `styles_headerLogo__z95Lk`,
	"mobileOnly": `styles_mobileOnly__BZSmu`,
	"desktopAvatar": `styles_desktopAvatar__wTUtZ`,
	"userButtonAvatar": `styles_userButtonAvatar__w3GF8`,
	"userButtonPopoverCard": `styles_userButtonPopoverCard__VlzFB`,
	"popoverActionButton": `styles_popoverActionButton__D0VZS`,
	"popoverCustomItemButton": `styles_popoverCustomItemButton__pIMSQ`,
	"popoverActions": `styles_popoverActions__6jlbb`,
	"userPreview": `styles_userPreview__UjdPI`,
	"identifierText": `styles_identifierText__0dK+9`,
	"secondaryIdentifierText": `styles_secondaryIdentifierText__Pr7iF`,
	"hide": `styles_hide__q8J6s`,
	"signOutIcon": `styles_signOutIcon__IVM9z`,
	"signOutIconBox": `styles_signOutIconBox__E3cFO`,
	"sidebarToggle": `styles_sidebarToggle__DW2A6`
};
export default ___CSS_LOADER_EXPORT___;
